import { format, subYears } from 'date-fns';

export const isAtLeast18YearsOld = (birthDate: string) => {
  const eighteenYearsAgoDate = subYears(new Date(), 18);
  const formatYearMonthDate = (inputDate: Date) =>
    format(inputDate, 'yyyy-MM-dd');
  const maxBirthDateString = `${formatYearMonthDate(eighteenYearsAgoDate)}`;
  return birthDate <= maxBirthDateString;
};

export const isMinor = (birthDate: string) => !isAtLeast18YearsOld(birthDate);
